export default __webpack_public_path__ + "static/media/pageNotFound.4c668686.png";